import React, { Suspense } from 'react';
import { GlobalStyles } from 'twin.macro';
import { Global } from '@emotion/react';
import { stylesBase, stylesCarousel, stylesFont } from './theme';
import { Header } from './sections';
import { MobileFooterMenu, SlideInMenu } from './menus';
import { Container } from './container';
import { LoadingDots } from './loading';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import {
  AppContextProvider,
  ConsentScripts,
  UserContextProvider,
  RouterContextProvider,
  RequestContextProvider,
  PreferenceContextProvider,
  ModalContextProviderOverlay,
  ModalContextProviderBackground,
  RouterContext,
} from './context';
import { ScrollToTop, ScrollToTopButton } from './scroll';
import { ImageSlider } from './item';
import { AppWrapper } from './wrapper';
import { NotificationsContainer } from './notifications';
import { SoundBoard } from './soundboard';
import { AdsContextProvider } from './ads/AdsContext';

Helmet.displayName = 'helmet';

export const App = ({ helmetContext = {}, staticContext = {} }) => {
  return (
    <HelmetProvider context={helmetContext}>
      <GlobalStyles />
      <Global styles={stylesBase} />
      <Global styles={stylesCarousel} />
      <Global styles={stylesFont} />
      <ConsentScripts />
      <UserContextProvider staticContext={staticContext}>
        <RequestContextProvider staticContext={staticContext}>
          <PreferenceContextProvider staticContext={staticContext}>
            <AdsContextProvider>
              <RouterContextProvider>
                <AppContextProvider>
                  <AppWrapper>
                    <SoundBoard />
                    <ImageSlider />
                    <ScrollToTop />
                    <Header>
                      <ModalContextProviderOverlay>
                        <SlideInMenu />
                      </ModalContextProviderOverlay>
                    </Header>
                    <ModalContextProviderBackground>
                      <Container noSpacing>
                        <Suspense fallback={<LoadingDots />}>
                          <RouterContext.Consumer>
                            {({ routeMatch }) => {
                              return routeMatch;
                            }}
                          </RouterContext.Consumer>
                        </Suspense>
                        <ScrollToTopButton />
                      </Container>
                    </ModalContextProviderBackground>
                  </AppWrapper>
                  <MobileFooterMenu />
                </AppContextProvider>
              </RouterContextProvider>
            </AdsContextProvider>
          </PreferenceContextProvider>
        </RequestContextProvider>
      </UserContextProvider>
      <NotificationsContainer />
    </HelmetProvider>
  );
};
